(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.announcementBar = this.closest('.announcement-bar-section');

      // TODO: Old header support - can remove if removing `header.liquid` section
      const stickyHeader = document.querySelector('sticky-header');
      if (stickyHeader) {
        this.header = stickyHeader.parentNode;
      }
      this.closeButton = document.querySelector('.utility-bar__close-button');

      this.closeButton.addEventListener('click', this.closeAnnouncementBar.bind(this));

      this.setAnnouncementBarHeight();
      window.addEventListener('resize', this.setAnnouncementBarHeight.bind(this));
    }

    setAnnouncementBarHeight() {
      document.documentElement.style.setProperty('--announcement-bar-height', `${this.announcementBar.offsetHeight}px`);
      document.documentElement.style.setProperty(
        '--negative-announcement-bar-height',
        `-${this.announcementBar.offsetHeight}px`,
      );

      // TODO: Old header support - can remove if removing `header.liquid` section
      if (!this.header) {
        return;
      }
      this.header.classList.add('adjust-header-position');
    }

    closeAnnouncementBar() {
      // TODO: should we save that the user closed the bar in a cookie so it doesn't appear again?
      this.announcementBar.classList.add('is-closed');
      // Fix when the navbar is transparent
      this.header.style.top = 0;
      setTimeout(() => {
        this.announcementBar.remove();
      }, 500);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-v2"]) return;
  try {
    
  (function () {
    customElements.whenDefined('overlay-component').then(() => {
      class HeaderMenuOverlay extends OverlayComponent {
        #events = ['open', 'close', 'change'];
        isValidEventName(name) {
          if (!name.startsWith('header-menu-overlay:')) return false;
          name = name.replace('header-menu-overlay:', '');
          return this.#events.includes(name);
        }

        #root = null;
        #bodyController = null;

        #localization = {
          root: null,
          buttons: [],
        };

        #emit(eventName, detail) {
          this.dispatchEvent(
            new CustomEvent(`header-menu-overlay:${eventName}`, {
              bubbles: false,
              detail,
            }),
          );
        }

        constructor() {
          super();
        }

        connectedCallback() {
          super.connectedCallback();
          this.#root = this.querySelector('[data-overlay-container]');

          customElements.whenDefined('body-controller').then(() => {
            this.#bodyController = document.querySelector('body-controller');
          });

          this.#handleOpenBound = this.#handleOpen.bind(this);
          this.addEventListener('overlay-component:open', this.#handleOpenBound);

          this.#handleCloseBound = this.#handleClose.bind(this);
          this.addEventListener('overlay-component:close', this.#handleCloseBound);

          this.#openSubmenuFromURLHashBound = this.#openSubmenuFromURLHash.bind(this);
          window.addEventListener('hashchange', this.#openSubmenuFromURLHashBound);

          if (window.readyState === 'complete') {
            this.#openSubmenuFromURLHash();
          } else {
            window.addEventListener('load', () => this.#openSubmenuFromURLHash());
          }

          if (this.#root) {
            const disclosures = this.#root.querySelectorAll('disclosure-component');
            this.#handleDisclosureShowBound = this.#handleDisclosureShow.bind(this);
            disclosures.forEach((disclosure) => {
              disclosure.addEventListener('disclosure-component:show', this.#handleDisclosureShowBound);
            });
          }

          this.#localization.root = this.#root?.querySelector('[data-localization-form-js]') || null;
          this.#localization.buttons = this.#localization.root?.querySelectorAll('button[value]') || [];
          if (this.#localization.buttons.length > 0) {
            this.#handleLocalizationButtonClickBound = this.#handleLocalizationButtonClick.bind(this);

            this.#localization.buttons.forEach((button) => {
              button.addEventListener('click', this.#handleLocalizationButtonClickBound);
            });
          }
        }

        disconnectedCallback() {
          super.disconnectedCallback();
          this.removeEventListener('overlay-component:close', this.#handleCloseBound);

          window.removeEventListener('hashchange', this.#openSubmenuFromURLHashBound);

          if (this.#root) {
            const disclosures = this.#root.querySelectorAll('disclosure-component');
            disclosures.forEach((disclosure) => {
              disclosure.removeEventListener('disclosure-component:show', this.#handleDisclosureShowBound);
            });
          }

          if (this.#localization.buttons.length > 0) {
            this.#localization.buttons.forEach((button) => {
              button.removeEventListener('click', this.#handleLocalizationButtonClickBound);
            });
          }
        }

        #handleLocalizationButtonClickBound = null;
        #handleLocalizationButtonClick(e) {
          const localizationRoot = this.#localization.root;
          const form = localizationRoot?.querySelector('form');

          if (!localizationRoot || !form) return;

          const nextLang = e.currentTarget.getAttribute('value');

          if (!nextLang) return;

          // Switch checked state
          this.#localization.buttons.forEach((button) => button.removeAttribute('data-checked'));
          e.currentTarget.setAttribute('data-checked', 'true');

          // Update locale_code input
          const localeCodeInput = form.querySelector('input[name="locale_code"]');
          if (localeCodeInput) {
            localeCodeInput.value = nextLang;
          }

          form.submit();
        }

        #openSubmenuFromURLHashBound = null;
        #openSubmenuFromURLHash(e) {
          const hash = window.location.hash;

          if (!hash) return;

          const id = hash.replace('#', '');
          const idWithPrefix = id.startsWith('header_submenu_') ? id : `header_submenu_${id}`;
          const submenu = this.#root?.querySelector(`#${idWithPrefix}`);

          if (submenu) {
            e.preventDefault();
            this.open();
            this.openSubmenu(idWithPrefix);
          }
        }

        openSubmenu(submenuId) {
          const submenu = this.#root?.querySelector(`#${submenuId}`);
          if (!submenu) return;

          if (!this.open) {
            this.open();
          }

          submenu.show();
        }

        closeSubmenu(submenuId) {
          const submenu = this.#root?.querySelector(`#${submenuId}`);
          if (!submenu) return;
          submenu.hide();
        }

        open() {
          super.open();
          if (this.#bodyController) {
            this.#bodyController.setAttribute('inert', '');
          }
        }
        close() {
          if (this.#bodyController) {
            this.#bodyController.removeAttribute('inert');
          }
          super.close();
          this.#hideDisclosures();
        }

        #handleOpenBound = null;
        #handleOpen() {
          this.#emit('open');
          this.#emit('change', { open: true });
        }

        #handleCloseBound = null;
        #handleClose() {
          this.#emit('close');
          this.#emit('change', { open: false });
        }

        #handleDisclosureShowBound = null;
        #handleDisclosureShow(e) {
          this.#hideDisclosures({ skip: e.currentTarget });
        }
        #hideDisclosures({ skip = null } = {}) {
          const disclosures = this.#root?.querySelectorAll('disclosure-component');

          disclosures?.forEach((disclosure) => {
            if (disclosure === skip) return;
            disclosure.hide({ returnFocus: false });
          });
        }
      }

      customElements.define('header-menu-overlay', HeaderMenuOverlay);
    });

    class HeaderBar extends HTMLElement {
      host = null;

      #events = ['change'];
      isValidEventName(name) {
        if (!name.startsWith('header-bar:')) return false;
        name = name.replace('header-bar:', '');
        return this.#events.includes(name);
      }

      #menu = null;

      #bodyController = null;

      #visibilityState = 'visible';
      get visibilityState() {
        return this.#visibilityState;
      }
      #setVisibilityState(value) {
        if (value === this.#visibilityState) return;
        if (!['visible', 'hidden'].includes(value)) {
          console.error(`header-v2.liquid - StickyHeader: Invalid visibility state: ${value}`);
          return;
        }
        this.#visibilityState = value;
        this.#emit('visibility', value);
      }

      #positionState = 'static';
      get positionState() {
        return this.#positionState;
      }
      #setPositionState(value) {
        if (value === this.#positionState) return;
        if (!['static', 'sticky'].includes(value)) {
          console.error(`header-v2.liquid - StickyHeader: Invalid position state: ${value}`);
          return;
        }
        this.#positionState = value;
        this.setAttribute('data-position-state', value);
        this.#emit('position', value);
      }

      #emit(type, value) {
        this.dispatchEvent(
          new CustomEvent('header-bar:change', {
            bubbles: false,
            detail: { type, value },
          }),
        );
      }

      constructor() {
        super();
      }

      connectedCallback() {
        this.host = this.parentNode;

        const positionState = this.getAttribute('data-position-state') || 'static';
        this.#positionState = positionState;

        // Initialize scroll & resize listeners
        customElements.whenDefined('body-controller').then(() => {
          this.#bodyController = document.querySelector('body-controller');
          if (!this.#bodyController) return;

          const visibilityState = document.body.getAttribute(
            this.#bodyController.attributes.stickyHeaderVisibilityState,
          );
          this.#visibilityState = visibilityState;

          this.#handleScrollBound = this.#handleScroll.bind(this);
          this.#bodyController.on('scroll', this.#handleScrollBound);

          this.#handleResizeBound = this.#handleResize.bind(this);
          this.#bodyController.on('resize', this.#handleResizeBound);

          this.#computeThresholds();
          this.#computePositionState();
        });
      }

      disconnectedCallback() {
        if (this.#bodyController) {
          if (this.#handleScrollBound) {
            this.#bodyController.off('scroll', this.#handleScrollBound);
          }

          if (this.#handleResizeBound) {
            this.#bodyController.off('resize', this.#handleResizeBound);
          }
        }
      }

      #colorChangeThreshold = 0;

      #handleResizeBound = null;
      #handleResize() {
        this.#computeThresholds();
      }
      #computeThresholds() {
        if (!this.#bodyController) return;

        const rect = this.getBoundingClientRect();

        const firstSectionWithHeaderTheme = document.querySelector(
          'body-controller [data-section-wrapper] > .shopify-section:has([data-header-theme])',
        );

        if (firstSectionWithHeaderTheme) {
          const rect = firstSectionWithHeaderTheme.getBoundingClientRect();
          this.#colorChangeThreshold = rect.height + (this.#bodyController.state.scrollY + rect.top);
        } else {
          this.#colorChangeThreshold = rect.height + (this.#bodyController.state.scrollY === 0 ? rect.top : 0) + 30;
        }
      }

      #handleScrollBound = null;
      #handleScroll() {
        this.#computePositionState();
      }
      #computePositionState() {
        if (!this.#bodyController) return;

        const scrollY = this.#bodyController.state.scrollY;

        const colorChangeThresholdMet = scrollY > this.#colorChangeThreshold;

        if (colorChangeThresholdMet) {
          this.setAttribute('data-color-state', 'auto');
        } else {
          this.setAttribute('data-color-state', 'theme');
        }
      }

      hide({ immediate = false } = {}) {
        if (immediate) {
          this.host?.classList.remove('animate');
        }
        this.#setVisibilityState('hidden');
      }

      show() {
        this.host?.classList.add('animate');
        this.#setVisibilityState('visible');
      }
    }

    customElements.define('header-bar', HeaderBar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const DURATION_LONG = 500;
  const MINIMUM_SCROLL_HEIGHT_TO_HIDE_HEADER = 500;
  const BOTTOM_MARGIN = 300;

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.bottomLogoIsSticky = false;
      this.isResizing = false;
      this.isNavigationOpening = false;
      this.observer = null; // Track the observer instance
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.stickyBottomLogo = document.querySelector('[data-sticky-logo-section-visible]');

      this.setHeaderHeight();

      this.isMobile = window.matchMedia('(max-width: 1023px)').matches;

      const isPageTooShortOnMobile =
        this.isMobile && document.body.scrollHeight - window.innerHeight <= MINIMUM_SCROLL_HEIGHT_TO_HIDE_HEADER;
      if (isPageTooShortOnMobile) {
        document.querySelector('body')?.setAttribute('data-sticky-logo-section-visible', 'true');
      }

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      this.onResizeHandler = this.onResize.bind(this);
      window.addEventListener('resize', this.onResizeHandler);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    onResize() {
      this.isResizing = true;

      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }

      this.reset();

      this.resizeTimeout = setTimeout(() => {
        this.setHeaderHeight();
        this.createObserver(); // This will now properly clean up the previous observer
        this.isResizing = false;
      }, 150);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);

      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
    }

    createObserver() {
      if (this.observer) {
        this.observer.disconnect();
      }

      this.observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
      });

      this.observer.observe(this.header);
    }

    checkStickyBottomLogo() {
      if (!this.stickyBottomLogo || this.isResizing || this.isNavigationOpening) return;

      const parent = this.stickyBottomLogo.parentElement;
      const logoRect = this.stickyBottomLogo.getBoundingClientRect();
      const parentRect = parent.getBoundingClientRect();
      const logoSectionThreshold = 300;

      this.bottomLogoIsSticky = logoRect.bottom + logoSectionThreshold >= parentRect.bottom;
    }

    onScroll() {
      const isPageTooShort = document.body.scrollHeight - window.innerHeight <= MINIMUM_SCROLL_HEIGHT_TO_HIDE_HEADER;
      if (this.isResizing || isPageTooShort) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // If header is still opening, but we reach the top of the page, reset immediately
      if (this.isNavigationOpening) {
        if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.checkStickyBottomLogo();

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const triggerBottom = this.headerBounds.bottom + BOTTOM_MARGIN;

      if (scrollTop > this.currentScrollTop && scrollTop > triggerBottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > triggerBottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal && !this.bottomLogoIsSticky) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      const leftMenuOverlay = document.querySelector('#Menu-left-Overlay .menu-overlay-container');
      const isMenuOpen = leftMenuOverlay && leftMenuOverlay.classList.contains('is-open');

      const isPageTooShortOnMobile =
        this.isMobile && document.body.scrollHeight - window.innerHeight <= MINIMUM_SCROLL_HEIGHT_TO_HIDE_HEADER;
      if (isPageTooShortOnMobile) return;

      if (this.headerIsAlwaysSticky || this.isResizing || this.isNavigationOpening || isMenuOpen) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.querySelector('body')?.setAttribute('data-sticky-logo-section-visible', 'true');
    }

    reveal() {
      if (this.headerIsAlwaysSticky || this.isResizing || this.isNavigationOpening) return;

      this.isNavigationOpening = true;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

      const isPageTooShortOnMobile =
        this.isMobile && document.body.scrollHeight - window.innerHeight <= MINIMUM_SCROLL_HEIGHT_TO_HIDE_HEADER;
      if (!this.bottomLogoIsSticky && !isPageTooShortOnMobile) {
        document.querySelector('body')?.setAttribute('data-sticky-logo-section-visible', 'false');
      }

      this.isScrolling = setTimeout(() => {
        this.isNavigationOpening = false;
      }, DURATION_LONG);
    }

    reset() {
      if (this.headerIsAlwaysSticky || this.isResizing) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.isNavigationOpening = false;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-settings"]) return;
  try {
    
  class MainSettings extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.headerElement = document.querySelector('.shopify-section.section-header');
      this.announcementBarElement = document.querySelector('.announcement-bar-section');
    }
  }

  customElements.define('main-settings', MainSettings);

  } catch(e) { console.error(e); }
})();
})();
